import request from '@/framework/utils/request'

// 品类树
export function getCategoryTree(data) {
  return request({
    url: '/system/category/tree',
    method: 'post',
    data
  })
}

// 组织树
export function getOrgTree(params) {
  return request({
    url: '/system/org/getTree',
    method: 'get',
    params
  })
}

// 数据字典(单个)
export function getDictList(code) {
  return request({
    url: '/system/dict/selectDictList',
    method: 'post',
    data: {
      codelist: [code]
    }
  })
}

// 数据字典(多个)
export function getBatchDictList(codelist) {
  return request({
    url: '/system/dict/selectDictList',
    method: 'post',
    data: {
      codelist
    }
  })
}

// 币种
export function getCurrency() {
  return request({
    url: '/system/currency/page',
    method: 'get',
    params: {
      pageSize: 1000
    }
  })
}
